module.exports = __webpack_public_path__ + "static/media/3n.867e957e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/3n.svg
// module id = 152
// module chunks = 0